export default "__VITE_ASSET__DoCJeS9W__"